<ng-container *ngIf="dataSource.loading$ | async; else search">
  <mat-progress-bar mode="indeterminate" />
</ng-container>

<ng-template #search>
  <pt-search-field class="layout-margin">
    <input
      #search
      matInput
      type="text"
      placeholder="Search Waitlist"
      (keyup)="applyFilter(search.value)"
    />
  </pt-search-field>
</ng-template>

<mat-table matSort matSortActive="score" [dataSource]="dataSource">
  <mat-header-row *matHeaderRowDef="columnsToDisplay" />
  <mat-row *matRowDef="let myRowData; columns: columnsToDisplay" />

  <ng-container matColumnDef="add">
    <mat-header-cell *matHeaderCellDef fxFlex="7">Add</mat-header-cell>
    <mat-cell
      *matCellDef="let waitListCandidate"
      class="mat-column-select"
      fxFlex="6"
    >
      <button
        *ngIf="
          (waitListCandidate | map: isGapCandidate$ : this | async) === false;
          else isCandidateButton
        "
        mat-icon-button
        matTooltip="Add candidate"
        (click)="addToShortlist(waitListCandidate, gap)"
      >
        <mat-icon>person_add</mat-icon>
      </button>
      <ng-template #isCandidateButton>
        <span matTooltip="Already a candidate">
          <button mat-icon-button disabled>
            <mat-icon>done</mat-icon>
          </button>
        </span>
      </ng-template>
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="edit">
    <mat-header-cell *matHeaderCellDef fxFlex="6">Edit</mat-header-cell>
    <mat-cell
      *matCellDef="let waitListCandidate"
      class="mat-column-select"
      fxFlex="5"
    >
      <button
        mat-icon-button
        matTooltip="Edit Waitlist Settings"
        (click)="openWaitlistConfiguration(waitListCandidate)"
      >
        <mat-icon>assignment</mat-icon>
      </button>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="patient">
    <mat-header-cell *matHeaderCellDef mat-sort-header>
      Patient
    </mat-header-cell>
    <mat-cell *matCellDef="let waitListCandidate">
      {{ waitListCandidate.candidate.patient.name }}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="practitioner">
    <mat-header-cell *matHeaderCellDef mat-sort-header>
      Practitioner
    </mat-header-cell>
    <mat-cell *matCellDef="let waitListCandidate">
      {{ waitListCandidate.appointment.practitionerName }}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="duration">
    <mat-header-cell *matHeaderCellDef fxFlex="15" mat-sort-header>
      Duration
    </mat-header-cell>
    <mat-cell *matCellDef="let waitListCandidate" fxFlex="15">
      <span>{{ waitListCandidate.appointment | map: duration }} mins</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="appointment">
    <mat-header-cell *matHeaderCellDef mat-sort-header>
      Appointment
    </mat-header-cell>
    <mat-cell *matCellDef="let waitListCandidate">
      <a
        href="javascript:void(0);"
        [matTooltip]="waitListCandidate.appointment | map: getTreatment | async"
        (click)="viewAppointmentCard(waitListCandidate.appointment)"
      >
        <ng-template #noAppointment>Unscheduled</ng-template>
        <span
          *ngIf="
            waitListCandidate.appointment | map: hasEvent;
            else noAppointment
          "
        >
          <ng-container
            *ngIf="
              waitListCandidate.appointment | map: getAppointmentFrom as from
            "
          >
            {{ from | moment | amDifference: (today | moment) : 'days' }}
          </ng-container>
          days &#64;
          <pr-formatted-event-field
            *ngIf="
              waitListCandidate.appointment
                | map: getAppointmentEvent
                | async as event
            "
            field="from"
            format="hh:mma"
            [event]="event"
          />
        </span>
      </a>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="score">
    <mat-header-cell *matHeaderCellDef mat-sort-header>Score</mat-header-cell>
    <mat-cell *matCellDef="let waitListCandidate">
      <div class="rating-score">
        <pr-appointment-score
          [scoreType]="appointmentScoreType.GapSuggestionWithWaitlist"
          [score]="waitListCandidate.appointment | map: getMatchScore : this"
        />
      </div>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="urgency">
    <mat-header-cell *matHeaderCellDef mat-sort-header>
      Urgency
    </mat-header-cell>
    <mat-cell *matCellDef="let waitListCandidate">
      <div class="urgency">
        <mat-icon
          *ngIf="waitListCandidate.appointment.urgency >= 1"
          color="primary"
          >local_hospital</mat-icon
        >
        <mat-icon
          *ngIf="waitListCandidate.appointment.urgency >= 2"
          color="primary"
          >local_hospital</mat-icon
        >
        <mat-icon
          *ngIf="waitListCandidate.appointment.urgency >= 3"
          color="primary"
          >local_hospital</mat-icon
        >
      </div>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="warnings">
    <mat-header-cell *matHeaderCellDef>Warnings</mat-header-cell>
    <mat-cell *matCellDef="let waitListCandidate">
      <pr-wait-list-warnings
        [gap]="gap"
        [waitListCandidate]="waitListCandidate"
      />
    </mat-cell>
  </ng-container>
</mat-table>

<div fxLayoutAlign="space-between center">
  <div fxLayoutGap="16px">
    <button
      *prHasPermission="[calendarEventsManagePermission]"
      mat-stroked-button
      class="block-out-time"
      matTooltip="Create a blocking event to fill this gap"
      (click)="blockTime(gap)"
    >
      Block-Out Time
    </button>
    <button
      mat-flat-button
      color="primary"
      matTooltip="Create appointment with this gap as the filter criteria"
      (click)="appointmentFromGap(gap)"
    >
      Create Appointment
    </button>
  </div>
  <mat-paginator
    #paginator
    showFirstLastButtons
    [length]="dataSource.data.length"
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
  />
</div>
